import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import styles from "../styles/SubNav.module.scss";
import useDarkMode from "use-dark-mode";

const SubNav = ({ items }) => {
  const darkMode = useDarkMode(false);
  return (
    <div className={classNames(styles.container, { [styles.dark]: darkMode.value })}>
      {items?.map(({ image, padLeft, textLeft, textRight, url }) => (
        <div className={styles.item} key={url}>
          <Link className={classNames({ [styles.padLeft]: padLeft })} to={url}>
            {image}
            <div className={styles.text}>
              <span className={styles.page}>{textLeft}</span>
              <span className={styles.count}>{textRight}</span>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

SubNav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.element,
      textLeft: PropTypes.string.isRequired,
      textRight: PropTypes.string,
      url: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};

export default SubNav;
